// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../style/theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.brandImage_jIKX4 {
	height: 40px;
}

.logoText_ytA5M {
	color: white;
}

.deleteButtonContainer_s_fdj {
	vertical-align: middle;
	line-height: 100%;
	cursor: pointer;
}

.fullWidth_xvo71 {
	width: 100%;
}

.projectItem_ufK7p {
	height: 100%;
	cursor: pointer;
}

.header_umBgl {
	height: 100%;
}

.headerBar_qIo6w {
	background: white;
}

.content_wPzBQ {
	background: white;
}

.brand_QMt6X {
	padding-left: 15px;
}

.homeScreen_f8Vdd {
	padding: 20px;
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
}

.content_wPzBQ {
	position: absolute;
	top: 50px;
	left: 0;
	right: 0;
	bottom: 0;
	overflow: auto;
}

.content_wPzBQ .projectButton_qsE2C {
	padding: 20px;
	margin: 16px;
	font-size: 20px;
	white-space: normal;
	border-radius: 0;
  /*box-shadow: 0 5px 8px rgba(0,0,0,0.05);*/
	width: 180px;
	min-height: 98px;
	padding: 20px 40px;
}

.content_wPzBQ .area_JEF1x {
	background-color: var(--color-base050, #F3F5F6);
}

.content_wPzBQ .projectButton_qsE2C.delete_W6iKB {
	border-color: var(--pink) !important;
}

.content_wPzBQ .projectButton_qsE2C.delete_W6iKB:hover {
	border-color: var(--pink) !important;
	background: var(--pink) !important;
	color: white;
	text-shadow: none;
}

.content_wPzBQ .newProjectButton_fv__i {
	position: absolute;
	right: 68px;
	top: 16px;
	Nfont-size: 32px;
	margin: 20px;
	width: 40px;
	height: 40px;
	color: white;
	background: var(--green);
	border-radius: 50%;
}

.content_wPzBQ .deleteModeButton_UG9ns {
	position: absolute;
	right: 8px;
	top: 16px;
	Nfont-size: 32px;
	margin: 20px;
	width: 40px;
	height: 40px;
	color: white;
	background: var(--grey);
	border-radius: 50%;
}

.content_wPzBQ .deleteModeButton_UG9ns:hover {
	border-color: var(--pink) !important;
	background: var(--pink) !important;
	color: white;
	text-shadow: none;
}

.content_wPzBQ .newProjectButton_fv__i:focus,
.content_wPzBQ .newProjectButton_fv__i:active,
.content_wPzBQ .newProjectButton_fv__i:focus:active,
.content_wPzBQ .deleteModeButton_UG9ns:focus,
.content_wPzBQ .deleteModeButton_UG9ns:active,
.content_wPzBQ .deleteModeButton_UG9ns:focus:active {
	box-shadow: none;
	outline: none;
}

.newProjectDialog_qrqtH {
	overflow: visible !important;
}

.newProjectDialogHeader_l30Ns {
	overflow: visible !important;
}

.newProjectDialogBody_HKqxD {
	overflow: visible !important;
}

.deleteTextField_rD7IX,
.deleteTextField_rD7IX:focus {
	font-size: 16;
}

.win_Xy5j8.users_V80A6,
.win_Xy5j8.events__4Qwf {
	background: var(--color-brand900);
	height: 100%;
	border-radius: 0;
}

.win_Xy5j8.events__4Qwf {
	border-right: 1px solid #707070;
	border-left: 1px solid #707070;
}

.navContainer_mxm6M {
	height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/screens/main/style.css"],"names":[],"mappings":"AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,sBAAsB;CACtB,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,kBAAkB;CAClB,MAAM;CACN,SAAS;CACT,OAAO;CACP,QAAQ;AACT;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,OAAO;CACP,QAAQ;CACR,SAAS;CACT,cAAc;AACf;;AAEA;CACC,aAAa;CACb,YAAY;CACZ,eAAe;CACf,mBAAmB;CACnB,gBAAgB;EACf,0CAA0C;CAC3C,YAAY;CACZ,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,+CAA+C;AAChD;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,oCAAoC;CACpC,kCAAkC;CAClC,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,SAAS;CACT,gBAAgB;CAChB,YAAY;CACZ,WAAW;CACX,YAAY;CACZ,YAAY;CACZ,wBAAwB;CACxB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,SAAS;CACT,gBAAgB;CAChB,YAAY;CACZ,WAAW;CACX,YAAY;CACZ,YAAY;CACZ,uBAAuB;CACvB,kBAAkB;AACnB;;AAEA;CACC,oCAAoC;CACpC,kCAAkC;CAClC,YAAY;CACZ,iBAAiB;AAClB;;AAEA;;;;;;CAMC,gBAAgB;CAChB,aAAa;AACd;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;;CAEC,aAAa;AACd;;AAEA;;CAEC,iCAAiC;CACjC,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,8BAA8B;AAC/B;;AAEA;CACC,YAAY;AACb","sourcesContent":["@import \"../../style/theme.css\";\n\n.brandImage {\n\theight: 40px;\n}\n\n.logoText {\n\tcolor: white;\n}\n\n.deleteButtonContainer {\n\tvertical-align: middle;\n\tline-height: 100%;\n\tcursor: pointer;\n}\n\n.fullWidth {\n\twidth: 100%;\n}\n\n.projectItem {\n\theight: 100%;\n\tcursor: pointer;\n}\n\n.header {\n\theight: 100%;\n}\n\n.headerBar {\n\tbackground: white;\n}\n\n.content {\n\tbackground: white;\n}\n\n.brand {\n\tpadding-left: 15px;\n}\n\n.homeScreen {\n\tpadding: 20px;\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n}\n\n.content {\n\tposition: absolute;\n\ttop: 50px;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\toverflow: auto;\n}\n\n.content .projectButton {\n\tpadding: 20px;\n\tmargin: 16px;\n\tfont-size: 20px;\n\twhite-space: normal;\n\tborder-radius: 0;\n  /*box-shadow: 0 5px 8px rgba(0,0,0,0.05);*/\n\twidth: 180px;\n\tmin-height: 98px;\n\tpadding: 20px 40px;\n}\n\n.content .area {\n\tbackground-color: var(--color-base050, #F3F5F6);\n}\n\n.content .projectButton.delete {\n\tborder-color: var(--pink) !important;\n}\n\n.content .projectButton.delete:hover {\n\tborder-color: var(--pink) !important;\n\tbackground: var(--pink) !important;\n\tcolor: white;\n\ttext-shadow: none;\n}\n\n.content .newProjectButton {\n\tposition: absolute;\n\tright: 68px;\n\ttop: 16px;\n\tNfont-size: 32px;\n\tmargin: 20px;\n\twidth: 40px;\n\theight: 40px;\n\tcolor: white;\n\tbackground: var(--green);\n\tborder-radius: 50%;\n}\n\n.content .deleteModeButton {\n\tposition: absolute;\n\tright: 8px;\n\ttop: 16px;\n\tNfont-size: 32px;\n\tmargin: 20px;\n\twidth: 40px;\n\theight: 40px;\n\tcolor: white;\n\tbackground: var(--grey);\n\tborder-radius: 50%;\n}\n\n.content .deleteModeButton:hover {\n\tborder-color: var(--pink) !important;\n\tbackground: var(--pink) !important;\n\tcolor: white;\n\ttext-shadow: none;\n}\n\n.content .newProjectButton:focus,\n.content .newProjectButton:active,\n.content .newProjectButton:focus:active,\n.content .deleteModeButton:focus,\n.content .deleteModeButton:active,\n.content .deleteModeButton:focus:active {\n\tbox-shadow: none;\n\toutline: none;\n}\n\n.newProjectDialog {\n\toverflow: visible !important;\n}\n\n.newProjectDialogHeader {\n\toverflow: visible !important;\n}\n\n.newProjectDialogBody {\n\toverflow: visible !important;\n}\n\n.deleteTextField,\n.deleteTextField:focus {\n\tfont-size: 16;\n}\n\n.win.users,\n.win.events {\n\tbackground: var(--color-brand900);\n\theight: 100%;\n\tborder-radius: 0;\n}\n\n.win.events {\n\tborder-right: 1px solid #707070;\n\tborder-left: 1px solid #707070;\n}\n\n.navContainer {\n\theight: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"brandImage": `brandImage_jIKX4`,
	"logoText": `logoText_ytA5M`,
	"deleteButtonContainer": `deleteButtonContainer_s_fdj`,
	"fullWidth": `fullWidth_xvo71`,
	"projectItem": `projectItem_ufK7p`,
	"header": `header_umBgl`,
	"headerBar": `headerBar_qIo6w`,
	"content": `content_wPzBQ`,
	"brand": `brand_QMt6X`,
	"homeScreen": `homeScreen_f8Vdd`,
	"projectButton": `projectButton_qsE2C`,
	"area": `area_JEF1x`,
	"delete": `delete_W6iKB`,
	"newProjectButton": `newProjectButton_fv__i`,
	"deleteModeButton": `deleteModeButton_UG9ns`,
	"newProjectDialog": `newProjectDialog_qrqtH`,
	"newProjectDialogHeader": `newProjectDialogHeader_l30Ns`,
	"newProjectDialogBody": `newProjectDialogBody_HKqxD`,
	"deleteTextField": `deleteTextField_rD7IX`,
	"win": `win_Xy5j8`,
	"users": `users_V80A6`,
	"events": `events__4Qwf`,
	"navContainer": `navContainer_mxm6M`
};
export default ___CSS_LOADER_EXPORT___;
